// Suppress TypeScript error for side-effect CSS import when no type declarations exist
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './config/authProvider';
import App from './App';
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
//import reportWebVitals from './reportWebVitals';
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import '@fontsource/roboto/300.css';
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import '@fontsource/roboto/400.css';
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import '@fontsource/roboto/500.css';
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import '@fontsource/roboto/700.css';
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import "./cssReset.css";
// @ts-ignore: Implicitly has an 'any' type because module has no type declarations
import "./custom.css";


const root = createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
     <AuthProvider>
        <BrowserRouter>
              <App />
        </BrowserRouter> 
     </AuthProvider>
    
  </React.StrictMode>
);




//
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const rootElement = document.getElementById('root');
//const root = createRoot(rootElement);

//delete later
//root.render(
 // <BrowserRouter basename={baseUrl}>
 //   <App />
 // </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
